export default __webpack_public_path__ + "static/designer-anthon-johansson-35a8d4f5cdce828e05ae968c506c2d04.png";